import React from 'react';
import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import ChargebackDocumentUploader from '../ChargebackDocumentUploader';

function UploadCardSkeleton(): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Title.Skeleton />
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="4">
          <Box display="flex" flexDirection="row" gap="2">
            <Icon.Skeleton />
            <Text.Skeleton />
          </Box>
          <Box display="flex" flexDirection="row" gap="2">
            <Icon.Skeleton />
            <Text.Skeleton />
          </Box>
          <Box display="flex" flexDirection="row" gap="2">
            <Icon.Skeleton />
            <Text.Skeleton />
          </Box>
          <ChargebackDocumentUploader.Skeleton />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default UploadCardSkeleton;
